<div class="flex h-full flex-col gap-4" *transloco="let t">
  <div class="flex justify-end gap-2">
    <div class="flex gap-2 opacity-0" [ngClass]="{ 'opacity-100': asinSelection().length > 0 }">
      <button
        iButton
        variant="destructive"
        size="sm"
        [loading]="deleteAsinLoading()"
        [disabled]="modalData.isReadOnly || this.asinSelection().length === this.strategyAsins().length"
        (click)="deleteProductFromStrategy(this.asinSelection())"
      >
        <IIcon name="trash" />
        {{ t("common.delete") }}
      </button>
      <button
        iButton
        variant="secondary"
        size="sm"
        [disabled]="modalData.isReadOnly || this.asinSelection().length === this.strategyAsins().length"
        (click)="moveProductsMainStrategy(this.asinSelection())"
      >
        <IIcon name="chevronsRight" />
        {{ t("common.move") }}
      </button>
    </div>
    <button iButton variant="secondary" size="sm" [disabled]="modalData.isReadOnly" (click)="openAddProductModal()">
      <IIcon name="add" />
      {{ t("common.add") }}
    </button>
  </div>

  <app-asin-selection
    class="min-h-0 flex-1"
    ineligibilityTag="SP"
    [customList]="strategyAsins()"
    [readonly]="modalData.isReadOnly"
    [csvExport]="true"
    [withBulk]="true"
    [withGroupByParent]="false"
    [(selectedAsins)]="asinSelection"
  />

  <ng-template #addProductModal>
    <div class="flex h-full flex-col gap-4">
      <app-asin-selection
        class="min-h-0 flex-1"
        ineligibilityTag="SP"
        [customList]="availableAsinsToAdd()"
        [(selectedAsins)]="addAsinSelection"
      />
      <div class="flex justify-end gap-2">
        <button iButton variant="secondary" size="sm" (click)="addProductModalRef?.close()">
          {{ t("common.cancel") }}
        </button>
        <button
          iButton
          size="sm"
          [disabled]="this.addAsinSelection().length === 0"
          [loading]="addAsinLoading()"
          (click)="addProductsToStrategy()"
        >
          {{ saveAddAsinLabel() }}
        </button>
      </div>
    </div>
  </ng-template>
</div>
